import type { Permission } from '@barbeiropro/contracts';
import {
  Bell,
  Bot,
  CalendarDays,
  ChartColumn,
  Gift,
  Globe,
  LayoutDashboard,
  Megaphone,
  Scissors,
  Settings,
  Users,
  UserRound,
  Wallet,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** basta uma das permissões */
  anyOf?: Permission[];
}

export const NAV_GROUPS: { label: string; items: NavItem[] }[] = [
  {
    label: 'Dia a dia',
    items: [
      { to: '/app', label: 'Painel', icon: LayoutDashboard },
      { to: '/app/agenda', label: 'Agenda', icon: CalendarDays, anyOf: ['agenda.read', 'agenda.read_all'] },
      { to: '/app/clientes', label: 'Clientes', icon: Users, anyOf: ['customers.read'] },
      { to: '/app/caixa', label: 'Caixa', icon: Wallet, anyOf: ['cash.operate', 'cash.manage'] },
    ],
  },
  {
    label: 'Gestão',
    items: [
      { to: '/app/relatorios', label: 'Relatórios', icon: ChartColumn, anyOf: ['reports.read', 'commissions.read'] },
      { to: '/app/servicos', label: 'Serviços', icon: Scissors, anyOf: ['catalog.manage'] },
      { to: '/app/equipe', label: 'Equipe', icon: UserRound, anyOf: ['catalog.manage', 'commissions.manage'] },
      { to: '/app/fidelidade', label: 'Fidelidade e planos', icon: Gift, anyOf: ['loyalty.manage'] },
      { to: '/app/campanhas', label: 'Campanhas', icon: Megaphone, anyOf: ['campaigns.manage'] },
      { to: '/app/assistente', label: 'Assistente', icon: Bot, anyOf: ['ai.use'] },
    ],
  },
  {
    label: 'Presença',
    items: [
      { to: '/app/site', label: 'Site', icon: Globe, anyOf: ['site.edit'] },
      { to: '/app/notificacoes', label: 'Notificações', icon: Bell, anyOf: ['settings.manage'] },
      { to: '/app/configuracoes', label: 'Configurações', icon: Settings, anyOf: ['settings.manage', 'members.manage', 'audit.read'] },
    ],
  },
];
